import {library} from '@fortawesome/fontawesome-svg-core';

import {
    faShare,
    faUsersCog,
    faInfo,
    faUserCog,
    faSignOutAlt,
    faUser as faUserSolid,
    faEllipsisV,
    faCheckCircle as faCheckCircleSolid,
    faTrash,
    faPlus,
    faStar,
    faChevronRight,
    faChevronUp,
    faChevronDown,
    faSearch,
    faFilter,
    faWalking,
    faCar,
    faBus,
    faExclamationTriangle,
    faArrowLeft,
    faTimes,
    faMinus,
    faUserFriends,
    faUserPlus,
    faBaby,
    faSyncAlt,
    faQuestionCircle
} from '@fortawesome/free-solid-svg-icons';
import {faWhatsapp, faViber} from '@fortawesome/free-brands-svg-icons';
import {faQuestionCircle as faQuestionCircleRegular, faEdit, faEnvelope, faCheckCircle as faCheckCircleRegular, faUser as faUserRegular} from '@fortawesome/free-regular-svg-icons';


library.add(
    faShare,
    faUserSolid,
    faUserRegular,
    faUsersCog,
    faInfo,
    faUserCog,
    faSignOutAlt,
    faQuestionCircleRegular,
    faEllipsisV,
    faWhatsapp,
    faViber,
    faCheckCircleSolid,
    faCheckCircleRegular,
    faEdit,
    faTrash,
    faPlus,
    faMinus,
    faStar,
    faEnvelope,
    faChevronRight,
    faChevronUp,
    faChevronDown,
    faSearch,
    faFilter,
    faWalking,
    faCar,
    faBus,
    faExclamationTriangle,
    faArrowLeft,
    faTimes,
    faUserFriends,
    faUserPlus,
    faBaby,
    faSyncAlt,
    faQuestionCircle
);